<template>

    <!--实时/历史安全指数-->
    <el-row :gutter="10" style="margin-top:10px;">
        <el-col :span="14">
            <el-card class="box-card" style="height:430px;">
                <div slot="header" class="clearfix">
                    <span>安全指数</span>
                </div>
                <el-row>
                    <el-col :span="6">
                        <el-tag type="info" style="width:100%;">安全总指数<span class="bold green-font font-18 margin-l-10">{{reliableValueAvg}}</span>
                        </el-tag>
                        <el-row>
                            <el-col :span="9"><span class="orange-font">第一名</span></el-col>
                            <el-col :span="15" style="text-align:right;">
                                <Tooltip4SortWith :levelArr="topFirst" fontClass="green-font"></Tooltip4SortWith>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="9"><span class="orange-font">第二名</span></el-col>
                            <el-col :span="15" style="text-align:right;">
                                <Tooltip4SortWith :levelArr="topSecond" fontClass="green-font"></Tooltip4SortWith>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="9"><span class="orange-font">第三名</span></el-col>
                            <el-col :span="15" style="text-align:right;">
                                <Tooltip4SortWith :levelArr="topThird" fontClass="green-font"></Tooltip4SortWith>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>
                        <el-row>
                            <el-col :span="9"><span class="orange-font">倒数第一名</span></el-col>
                            <el-col :span="15" style="text-align:right;">
                                <Tooltip4SortWith :levelArr="lastFirst" fontClass="green-font"></Tooltip4SortWith>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="9"><span class="orange-font">倒数第二名</span></el-col>
                            <el-col :span="15" style="text-align:right;">
                                <Tooltip4SortWith :levelArr="lastSecond" fontClass="green-font"></Tooltip4SortWith>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="9"><span class="orange-font">倒数第三名</span></el-col>
                            <el-col :span="15" style="text-align:right;">
                                <Tooltip4SortWith :levelArr="lastThird" fontClass="green-font"></Tooltip4SortWith>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="18">
                        <div ref="contrast" style="height:300px;width:100%;"></div>
                    </el-col>
                </el-row>

            </el-card>
        </el-col>
        <!--安全指数-->
        <!--安全指数分布-->
        <el-col :span="10">
            <el-card class="box-card" style="height:430px;">
                <div slot="header" class="clearfix">
                    <span>安全指数分布</span>
                </div>

                <div ref="distribution" style="height:300px;width:100%;"></div>

            </el-card>
        </el-col>
        <!--安全指数分布-->
    </el-row>

</template>

<script>

    import echarts from 'echarts'
    import realTime from "@/views/board/boss/reliable/realTime";
    import history from "@/views/board/boss/reliable/history"
    import {formatDate, parseDate} from "element-ui/src/utils/date-util";
    import Tooltip4SortWith from "@/views/board/boss/tooltip4SortWith";

    let that;

    export default {
        name: "reliable",

        components: {
            Tooltip4SortWith,
        },

        mixins: [realTime, history],

        props: {
            deptids: {
                type: Array,
            },
            deptMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        data() {
            return {
                topFirst: [],
                topSecond: [],
                topThird: [],

                lastFirst: [],
                lastSecond: [],
                lastThird: [],

                realFlag: true,     //查询实时/历史安全指数

                sortedDeptNameArr: [],       //排序后的部门安全指数图标数据
                sortedReliableValueArr: [],

            }
        },

        methods: {

            getTopLastThreeArrOper(sortedScoreArr, orgDataArr) {
                let first = [];
                let second = [];
                let third = [];
                for (let i = 0; i < sortedScoreArr.length; i++) {
                    for (let j = 0; j < orgDataArr.length; j++) {
                        if (sortedScoreArr[i] == orgDataArr[j].reliableValue && i == 0) {
                            first.push(orgDataArr[j].deptName + ':' + orgDataArr[j].reliableValue);
                        } else if (sortedScoreArr[i] == orgDataArr[j].reliableValue && i == 1) {
                            second.push(orgDataArr[j].deptName + ':' + orgDataArr[j].reliableValue);
                        } else if (sortedScoreArr[i] == orgDataArr[j].reliableValue && i == 2) {
                            third.push(orgDataArr[j].deptName + ':' + orgDataArr[j].reliableValue);
                        }
                    }
                }
                return [first, second, third];
            },

            //获取部门名次及其并列部门
            getTopLastThree(reliableValueArr) {
                let scoreSet = new Set();   //所有部门不重复的分数

                let orgDataArr = [];
                for (let i = 0; i < this.deptids.length; i++) {
                    let orgData = {};
                    orgData.deptName = this.deptMap.get(this.deptids[i]);
                    orgData.reliableValue = reliableValueArr[i];
                    scoreSet.add(reliableValueArr[i]);
                    orgDataArr.push(orgData);
                }

                this.sortContrastChartData(orgDataArr);

                let sortedScoreArr1 = (Array.from(scoreSet)).sort((a, b) => a > b ? 1 : a < b ? -1 : 0).reverse();
                [this.topFirst, this.topSecond, this.topThird] = this.getTopLastThreeArrOper(sortedScoreArr1, orgDataArr);
                let sortedScoreArr2 = (Array.from(scoreSet)).sort((a, b) => a > b ? 1 : a < b ? -1 : 0);
                [this.lastFirst, this.lastSecond, this.lastThird] = this.getTopLastThreeArrOper(sortedScoreArr2, orgDataArr);
            },

            //对部门安全指数echart图的数据进行排序
            sortContrastChartData(orgDataArr) {
                let sortedReliableValueDataArr = [...orgDataArr];
                sortedReliableValueDataArr.sort((a, b) => a.reliableValue > b.reliableValue ? 1 : a.reliableValue < b.reliableValue ? -1 : 0).reverse();
                this.sortedDeptNameArr = [];
                this.sortedReliableValueArr = [];
                for (let i = 0; i < sortedReliableValueDataArr.length; i++) {
                    this.sortedDeptNameArr.push(sortedReliableValueDataArr[i]['deptName']);
                    this.sortedReliableValueArr.push(sortedReliableValueDataArr[i]['reliableValue']);
                }
            },

            //安全指数分布chart
            renderDistributionChart(data) {
                let myChart = echarts.init(this.$refs.distribution);
                myChart.clear();
                let option = {
                    tooltip: {},
                    radar: {
                        // shape: 'circle',
                        name: {
                            textStyle: {
                                color: '#fff',
                                backgroundColor: '#999',
                                borderRadius: 3,
                                padding: [3, 5],
                                fontSize: 16,
                            }
                        },
                        center: ['50%', '55%'],
                        radius: 95,
                        indicator: [
                            {name: '事件', max: 100},
                            {name: '工单', max: 100},
                            {name: '编制', max: 100},
                            {name: '变更', max: 100},
                            {name: '问题', max: 100},
                            {name: '进出登记', max: 100},
                        ]
                    },

                    series: [{
                        name: '安全指数分布',
                        type: 'radar',
                        // areaStyle: {normal: {}},
                        itemStyle: {normal: {areaStyle: {type: 'default'}}},
                        data: [
                            {
                                value: data,
                            }
                        ]
                    }]
                };

                myChart.setOption(option);
                window.onresize = myChart.resize;
            },

            //部门安全指数chart
            renderReliableValueChart(reliableValueArr) {
                this.getTopLastThree(reliableValueArr);

                let myChart = echarts.init(this.$refs.contrast);
                myChart.clear();
                let option = {
                    color: ['#13d06c'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    dataZoom: [
                        {
                            type: 'slider',
                            show: true,
                            start: 1,
                            end: 100
                        }
                    ],
                    grid: {
                        left: '5%',
                        right: '5%',
                        bottom: '15%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        data: this.sortedDeptNameArr,
                        "axisLabel": {
                            rotate: 50,
                        },
                    },
                    yAxis: {
                        type: 'value',

                    },
                    series: [
                        {
                            name: '安全指数',
                            type: 'bar',
                            data: this.sortedReliableValueArr,
                            markPoint: {
                                data: [
                                    {type: 'max', name: '最大值'},
                                    {type: 'min', name: '最小值'}
                                ]
                            }
                        }
                    ]
                };
                myChart.setOption(option);
            },

            getFirstDayOfMonth(date) {
                let current = date == null ? new Date() : date + '-01';
                current = parseDate(current, 'yyyy-MM-dd');
                return new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0, 0);
            },

            getLastDayOfMonth(date) {
                let current = date == null ? new Date() : date + '-01';
                current = parseDate(current, 'yyyy-MM-dd');
                let firstDateInNextMonth = new Date(current.getFullYear(), current.getMonth() + 1, 1, 0, 0, 0, 0);
                return new Date(firstDateInNextMonth.getTime() - 1);
            },

            query() {
                this.topFirst = [];
                this.topSecond = [];
                this.topThird = [];
                this.lastFirst = [];
                this.lastSecond = [];
                this.lastThird = [];
                this.sortedDeptNameArr = [];
                this.sortedReliableValueArr = [];
                if (this.deptids.length != 0) {
                    let searchStartDate = null;
                    let searchEndDate = null;
                    if (this.realFlag) {
                        if (formatDate(new Date(), 'dd') == "01") {
                            this.getRealtimeData();
                        } else {
                            searchStartDate = formatDate(this.getFirstDayOfMonth(this.searchDate), 'yyyy-MM-dd');
                            searchEndDate = formatDate(new Date(), 'yyyy-MM-dd');
                            this.getHistoryData(this.deptids, searchStartDate, searchEndDate);
                        }
                    } else {
                        searchStartDate = formatDate(this.getFirstDayOfMonth(this.searchDate), 'yyyy-MM-dd');
                        searchEndDate = formatDate(this.getLastDayOfMonth(this.searchDate), 'yyyy-MM-dd');
                        this.getHistoryData(this.deptids, searchStartDate, searchEndDate);
                    }
                }
            },
        },

        created() {
            that = this;
        },

        watch: {

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (formatDate(new Date(), 'yyyy-MM') == newVal) {
                        this.realFlag = true;
                    } else {
                        this.realFlag = false;
                    }
                    this.query();
                }
            },

            deptids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    this.query();
                }
            }

        },

        computed: {
            deptNames() {
                let names = [];
                for (let i = 0; i < this.deptids.length; i++) {
                    names.push(this.deptMap.get(this.deptids[i]));
                }
                return names;
            }
        },

    }

</script>

<style scoped>

</style>